import { FC, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { UserV3 } from '#types';
import { dashboardApiV3 } from '#api';
import { useAppContext, useSafeState } from '#hooks';
import { ApiStatus } from '#dashboard/components/apiStatus.component';
import { UserInformationV3 } from '#users/components/userInformationV3.component';
import { AssignEsimFormV3 } from '#users/components/assignEsimFormV3.component';
import { UserNotificationV3 } from '#users/components/userNotificationV3.component';

export const UserToDisplayV3: FC = () => {

    const { apiStatus } = useAppContext();
    const { email } = useParams();
    const [errorMessage, setErrorMessage] = useSafeState<string>('')
    const [user, setUser] = useSafeState<UserV3>({} as UserV3)
    const [displayAssignEsimForm, setDisplayAssignEsimForm] = useSafeState<boolean>(false);
    const [isLoading, setIsLoading] = useSafeState<boolean>(true);

    const fetchTargetUser = async () => {
        try {
            const response = await dashboardApiV3.searchUsersByEmail(email as string, true);
            setUser(response.data);
        } catch {
            setErrorMessage('User could not be found, please sign out, sign in and try again. If problem persists, please contact Alex')
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(
        () => {
            fetchTargetUser();
        },
        []
    );

    if (isLoading) {
        return <div className="lds-hourglass" />
    }

    if (!user?.email) {
        return <div className='app user-to-display-page'>
            <div className='main-dashboard-container mb-s pd-m'>
                <p className='status-message-failure bold'>{errorMessage}</p>
            </div>
        </div>
    }

    return <div className='app user-to-display-page'>
        <div style={{ alignItems: 'center', padding: 10 }} className='main-dashboard-container pb-m mb-s four-columns-expand-three'>
            <h1 className='selectable-text'>{user.firstName} {user.lastName} <span> &#x2705;</span> - {user?.email}</h1>
            {
                user.currentLocation ? <div className='three-rows-expand-one-three'>
                    <div />
                    <img style={{ width: 60, height: 35, marginLeft: 15, }} src={`https://flagcdn.com/w80/${user?.currentLocation?.toLowerCase()}.png`} />
                    <div />
                </div> : <div />
            }
            <div />
            <button onClick={() => setDisplayAssignEsimForm(!displayAssignEsimForm)} id='assign-esim-button' className='mr-m ml-m pd-s bold'>ASSIGN ESIM</button>
        </div>
        {apiStatus && <ApiStatus />}
        {displayAssignEsimForm && <AssignEsimFormV3 setDisplayAssignEsimForm={setDisplayAssignEsimForm} setUser={setUser} user={user} />}
        <UserInformationV3 user={user} />
        <UserNotificationV3 user={user} />
        <div className='main-dashboard-container mb-s pd-m'>
            {/* {user?.createdAt && <p>Joined ZIM on {formatDate(user?.createdAt)}</p>}
            {user?.updatedAt && <p>Last visited the app on {formatDate(user?.updatedAt)}</p>} */}
            {user.deviceInfo && <p>Device: {`${JSON.parse(user.deviceInfo).model}` || 'unknown'}</p>}
            <p>Nano ID: <span className='selectable-text'>{`${user.nanoID}` || 'unknown'}</span></p>
            <p>Sub: <span className='selectable-text'>{`${user.uuid || 'unknown'}`}</span></p>
        </div>
    </div>
}
